import { createBrowserRouter, Navigate } from 'react-router'
import { Shell } from './components/Shell'
import { StatusPage } from './components/StatusPage'
import { LoginPage } from './features/auth/LoginPage'
import { DashboardPage } from './features/dashboard/DashboardPage'
import { EditarDFDPage } from './features/dfd/EditarDFDPage'
import { NovoDFDPage } from './features/dfd/NovoDFDPage'
import { VerDFDPage } from './features/dfd/VerDFDPage'
import { EditarETPPage } from './features/etp/EditarETPPage'
import { NovoETPPage } from './features/etp/NovoETPPage'
import { SelecaoPrecosPage } from './features/etp/SelecaoPrecosPage'
import { VerETPPage } from './features/etp/VerETPPage'
import { ShellSuperAdmin } from './components/ShellSuperAdmin'
import { ArquivosAuditoriaPage } from './features/superAdmin/ArquivosAuditoriaPage'
import { ConversorPcaPage } from './features/superAdmin/ConversorPcaPage'
import {
  TabelaSusPage,
  TokensPage,
} from './features/superAdmin/FerramentasPage'
import {
  RagChunksPage,
  RagPage,
  RagTipoPage,
} from './features/superAdmin/RagPage'
import { PainelSuperAdminPage } from './features/superAdmin/PainelSuperAdminPage'
import { AuditoriaPage } from './features/auditoria/AuditoriaPage'
import { NovaAuditoriaPage } from './features/auditoria/NovaAuditoriaPage'
import { RelatorioAuditoriaPage } from './features/auditoria/RelatorioAuditoriaPage'
import { SelecaoDocumentosPage } from './features/auditoria/SelecaoDocumentosPage'
import { SusPage } from './features/sus/SusPage'
import { VerParecerPage } from './features/sus/VerParecerPage'
import { PesquisaJuridicaPage } from './features/jurisprudencia/PesquisaJuridicaPage'
import { VerPesquisaPage } from './features/jurisprudencia/VerPesquisaPage'
import { JuridicoPage } from './features/juridico/JuridicoPage'
import { VerPecaPage } from './features/juridico/VerPecaPage'
import { NovoCredenciamentoPage } from './features/credenciamento/NovoCredenciamentoPage'
import { VerCredenciamentoPage } from './features/credenciamento/VerCredenciamentoPage'
import { EditarEditalPage } from './features/edital/EditarEditalPage'
import { NovoEditalPage } from './features/edital/NovoEditalPage'
import { VerEditalPage } from './features/edital/VerEditalPage'
import { EditarTRPage } from './features/tr/EditarTRPage'
import { NovoTRPage } from './features/tr/NovoTRPage'
import { VerTRPage } from './features/tr/VerTRPage'
import { ProcessosPage } from './features/processos/ProcessosPage'
import { TarefasPage } from './features/tarefas/TarefasPage'
import { UsuariosAdminPage } from './features/admin/UsuariosAdminPage'

// basename /app: o nginx serve a SPA sob /app/ (plano SPA, §3.1)
export const roteador = createBrowserRouter(
  [
    { path: '/login', element: <LoginPage /> },
    {
      path: '/',
      element: <Shell />,
      children: [
        // "/" não tem identidade própria: o dashboard É a home
        { index: true, element: <Navigate to="/dashboard" replace /> },
        // Acompanhamento de geração — substitui as 10 páginas *_status.html
        { path: 'tasks/:tipo/:id', element: <StatusPage /> },
        // Piloto F3 — primeiro domínio 100% SPA
        { path: 'tarefas', element: <TarefasPage /> },
        // F4 — dashboard
        { path: 'dashboard', element: <DashboardPage /> },
        // F5 — hub do processo licitatório + formulário do DFD
        { path: 'processos', element: <ProcessosPage /> },
        { path: 'dfd/novo', element: <NovoDFDPage /> },
        // F5e — DFD gerado: leitura e edição
        { path: 'dfd/:id', element: <VerDFDPage /> },
        { path: 'dfd/:id/editar', element: <EditarDFDPage /> },
        // F6a — ETP: criação, leitura, edição e seleção de preços
        { path: 'etp/novo/:id', element: <NovoETPPage /> },
        { path: 'etp/:id', element: <VerETPPage /> },
        { path: 'etp/:id/editar', element: <EditarETPPage /> },
        { path: 'etp/:id/precos', element: <SelecaoPrecosPage /> },
        // F6b — TR: derivado do ETP
        { path: 'tr/novo/:id', element: <NovoTRPage /> },
        { path: 'tr/:id', element: <VerTRPage /> },
        { path: 'tr/:id/editar', element: <EditarTRPage /> },
        // Fase Edital — Edital competitivo (Art. 25) e Chamamento (Art. 79)
        { path: 'edital/novo/:id', element: <NovoEditalPage /> },
        { path: 'edital/:id', element: <VerEditalPage /> },
        { path: 'edital/:id/editar', element: <EditarEditalPage /> },
        { path: 'credenciamento/novo/:id', element: <NovoCredenciamentoPage /> },
        { path: 'credenciamento/:id', element: <VerCredenciamentoPage /> },
        // F7 — Jurídico: impugnação e defesa
        { path: 'juridico', element: <JuridicoPage /> },
        { path: 'juridico/:tipo', element: <JuridicoPage /> },
        { path: 'juridico/:tipo/:id', element: <VerPecaPage /> },
        // F8 — Pesquisa Jurisprudencial
        { path: 'jurisprudencia', element: <PesquisaJuridicaPage /> },
        { path: 'jurisprudencia/:id', element: <VerPesquisaPage /> },
        // F9 — Auditoria do SUS
        { path: 'sus', element: <SusPage /> },
        { path: 'sus/:id', element: <VerParecerPage /> },
        // Fase Admin comum — usuários do tenant (papel admin)
        { path: 'admin/usuarios', element: <UsuariosAdminPage /> },
        // F10 — Auditoria
        { path: 'auditoria', element: <AuditoriaPage /> },
        { path: 'auditoria/nova', element: <NovaAuditoriaPage /> },
        { path: 'auditoria/:id', element: <RelatorioAuditoriaPage /> },
        { path: 'auditoria/:id/selecao', element: <SelecaoDocumentosPage /> },
      ],
    },
    {
      // F11 — painel do super admin: layout PRÓPRIO (barra roxa, seletor de
      // prefeitura). Não é uma tela do sistema; é a administração dele.
      path: '/super-admin',
      element: <ShellSuperAdmin />,
      children: [
        { index: true, element: <Navigate to="/super-admin/prefeituras" replace /> },
        // rota específica ANTES da genérica: /auditorias/:id é a lista de
        // consultas de um processo, não a aba
        { path: 'auditorias/:processoId', element: <ArquivosAuditoriaPage /> },
        { path: 'pca', element: <ConversorPcaPage /> },
        { path: 'rag', element: <RagPage /> },
        { path: 'tabela-sus', element: <TabelaSusPage /> },
        { path: 'tokens', element: <TokensPage /> },
        { path: 'rag/documentos/:documentoId', element: <RagChunksPage /> },
        { path: 'rag/:tipoId', element: <RagTipoPage /> },
        { path: ':aba', element: <PainelSuperAdminPage /> },
      ],
    },
  ],
  { basename: '/app' },
)
